// extracted by mini-css-extract-plugin
export default {"root":"SimpleImage--root--E2y0b","hasMobileImage":"SimpleImage--hasMobileImage--2YRoP","ratio":"SimpleImage--ratio--1BILD"};